import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { queryClient } from '@/lib/queryClient';
import './index.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              fontSize: '13px',
              fontWeight: '500',
              borderRadius: '10px',
              padding: '12px 16px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
              maxWidth: '380px',
              lineHeight: '1.4',
            },
            success: {
              iconTheme: { primary: '#fff', secondary: '#16a34a' },
              style: {
                background: '#16a34a',
                color: '#fff',
              },
            },
            error: {
              iconTheme: { primary: '#fff', secondary: '#dc2626' },
              style: {
                background: '#dc2626',
                color: '#fff',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
